/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';


const NativeVideoPlayerModule = ({
  handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname, languages, activeLanguage,
}) => {
  const initialStateVideoPlayer = {
    type: 'NativeVideoPlayer',
    desktopUrl: '',
    mobileUrl: '',
    controls: false,
    muted: true,
    autoPlay: true,
    headline: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    ctaText: {
      es: '',
      en: '',
      ca: '',
      pt: '',
    },
    ctaUrl: '',
  };

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialStateVideoPlayer);
  const [isControlsOn, setControlsState] = useState(false);
  const [isMutedOn, setMutedState] = useState(true);
  const [isAutoPlayOn, setAutoPlayState] = useState(true);

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      if (component) {
        setControlsState(component.controls || false);
        setMutedState(component.muted || true);
        setAutoPlayState(component.autoPlay || true);
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  const setBooleans = (item) => {
    const { component } = components[index];
    switch (item) {
      case 'controls':
        setControlsState(!isControlsOn);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            controls: !isControlsOn,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'mute':
        setMutedState(!isMutedOn);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            muted: !isMutedOn,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      case 'autoPlay':
        setAutoPlayState(!isAutoPlayOn);
        if (index >= 0 && components.length) {
          const comp = {
            ...component,
            autoPlay: !isAutoPlayOn,
          };
          setState(comp);

          const componentObj = {
            id,
            component: comp,
          };

          handlerSetComponents(componentObj, index);
        }
        break;

      default:
        break;
    }
  };


  const inputHandler = (e) => {
    const { value, name, lang } = e.target;

    const { component } = components[index];

    let comp = {};

    if (name === 'headline' || name === 'ctaText') {
      comp = {
        ...component,
        [name]: {
          ...component[name],
          [lang.toLowerCase()]: value,
        },
      };
    } else {
      comp = {
        ...component,
        [name]: value,
      };
    }


    setState(comp);

    const componentObj = {
      id,
      component: comp,
    };
    handlerSetComponents(componentObj, index);
  };


  return (
    <>
      <div className="w-full bg-greyFilter px-5 rounded-lg flex flex-row pt-8 pb-4">
        <div className="pl-9 w-full ">

          <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8" htmlFor="desktopVideoUrl">
            Desktop Video Url
            <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="desktopUrl" type="text" value={state.desktopUrl} readOnly={reusableComponent && reusableComponent} />
          </label>
          <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8" htmlFor="mobileVideoUrl">
            Mobile Video Url
            <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="mobileUrl" type="text" value={state.mobileUrl} readOnly={reusableComponent && reusableComponent} />
          </label>

          <div className="flex justify-between">
            <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
              Show controls?
              <div className="pb-0 mt-6px ml-1">
                <label className="switch-no-text mb-0 pb-0 h-6">
                  <input className="switch-no-text" checked={isControlsOn} onChange={() => { setBooleans('controls'); }} type="checkbox" />
                  <div className="switch-slider-no-text btn-gr switch-round" />
                </label>
              </div>
            </label>
            <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
              Is Video Muted?
              <div className="pb-0 mt-6px ml-1">
                <label className="switch-no-text mb-0 pb-0 h-6">
                  <input className="switch-no-text" checked={isMutedOn} onChange={() => { setBooleans('mute'); }} type="checkbox" />
                  <div className="switch-slider-no-text btn-gr switch-round" />
                </label>
              </div>
            </label>
            <label className="flex flex-col font-americaMonoRegular text-xs w-1/8 justify-center uppercase text-black pt-0 items-center px-2">
              Is Auto Play On?
              <div className="pb-0 mt-6px ml-1">
                <label className="switch-no-text mb-0 pb-0 h-6">
                  <input className="switch-no-text" checked={isAutoPlayOn} onChange={() => { setBooleans('autoPlay'); }} type="checkbox" />
                  <div className="switch-slider-no-text btn-gr switch-round" />
                </label>
              </div>
            </label>
          </div>
          <div className="flex w-full justify-between">
            {languages.map(lang => (
              <div key={lang} className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block w-full' : 'hidden'}`}>
                <div className="flex">
                  <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8 w-full" htmlFor="videoUrl">
                    Headline
                    <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" lang={lang} onChange={inputHandler} name="headline" type="text" value={state.headline ? state.headline[lang.toLowerCase()] : ''} readOnly={reusableComponent && reusableComponent} />
                  </label>
                  <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8 w-full px-8" htmlFor="videoUrl">
                    CTA Text
                    <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" lang={lang} onChange={inputHandler} name="ctaText" type="text" value={state.ctaText ? state.ctaText[lang.toLowerCase()] : ''} readOnly={reusableComponent && reusableComponent} />
                  </label>
                </div>
              </div>
            ))}
            <label className="flex flex-col font-americaMonoRegular text-xs mt-1 uppercase text-black pb-8 w-1/2" htmlFor="videoUrl">
              CTA Url
              <input className="withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-full mt-1 ml-1 p-1 text-sm" onChange={inputHandler} name="ctaUrl" type="text" value={state.ctaUrl} readOnly={reusableComponent && reusableComponent} />
            </label>
          </div>
        </div>
      </div>
    </>

  );
};

NativeVideoPlayerModule.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
  activeLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
};
NativeVideoPlayerModule.defaultProps = {
  reusableComponent: null,
};

export default NativeVideoPlayerModule;
